import {formDataToRequestParams, getAxios} from './axios'
import {addAuthTokenData} from './member';

import {responseResolveInterceptor} from './interceptors';

export function getWallMaterial(params) {
    let axios = getAxios();

    return axios.request({
        url: '/wall_material/',
        method: 'get',
        params: addAuthTokenData(params)
    });
}

export function likeWallMaterial({id}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/wall/like/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function denounceWallMaterial({id}) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/member/wall/denounce/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id}))
    });
}

export function commentWallMaterial({id, comment}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/wall/comment/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({id, comment}))
    });
}

export function incrementAmateurFilmViews(id) {
    let axios = getAxios();
    
    return axios.request({
        url: '/member/wall/view/',
        method: 'post',
        data: formDataToRequestParams({'id' : id})
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/wallMaterial.js